import { render, staticRenderFns } from "./transportType.vue?vue&type=template&id=33dc0883&scoped=true"
import script from "./transportType.vue?vue&type=script&lang=js"
export * from "./transportType.vue?vue&type=script&lang=js"
import style0 from "./transportType.vue?vue&type=style&index=0&id=33dc0883&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc0883",
  null
  
)

export default component.exports